import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '../../molecules/dialogs/Dialog'
import { Button } from '../../atoms/Button'
import { useAuth } from '../../molecules/Auth'

const DownloadDialog = ({ popupInfo, onClosePopup }) => {
  const { user } = useAuth()

  return (
    <>
      {popupInfo.show && (
        <Dialog
          maxWidth="sm"
          buttonClose={false}
          renderTitle={<p className="header font-bold text-lg">Exportando {popupInfo.title}</p>}
          renderContent={
            <div className="border-neutral-300 py-6">
              <p>
                Cuando finalice el proceso, recibirás la información como un archivo de Excel en el correo
                <span className="font-bold"> {user.email}.</span>
              </p>
              <p className="pt-6">
                <span className="font-bold">Nota:</span> Si deseas exportar la información relacionada a otro indicador,
                puedes hacerlo después de recibir el archivo actual, para asegurar el óptimo rendimiento de la
                plataforma.
              </p>
            </div>
          }
          renderActions={
            <div className="md:contents inline-block">
              <Button size="full" className="md:w-40 w-full" onClick={onClosePopup}>
                Ok
              </Button>
            </div>
          }
          onClose={onClosePopup}
        />
      )}
    </>
  )
}

export default DownloadDialog

DownloadDialog.propTypes = {
  popupInfo: PropTypes.object.isRequired,
  onClosePopup: PropTypes.func.isRequired
}
